import {useState} from "react";
import {Button, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {UnitSystem} from "../../../../../api/Projects";
import {parseDimension} from "../components/DimensionEditor";

// A small modal for the "STD Height" hinge action: the user enters a nominal door
// height, and the caller derives the standard hinge spacing + count from it (the
// standard-height table) and applies them across all hinges as a custom override. The
// field accepts the project's unit system (imperial like `7'` / `84"`, metric like
// `2134 mm`); an empty/invalid or non-positive entry keeps the dialog open.
export function StdHeightDialog(props: {
    open: boolean;
    sys: UnitSystem;
    onClose: () => void;
    onSubmit: (nominalHeight: number) => void;
}) {
    const [value, setValue] = useState("");

    if(!props.open) return null;

    const parsed = parseDimension(value, props.sys);
    const valid = !isNaN(parsed) && parsed > 0;

    const submit = () => {
        if(!valid) return;
        props.onSubmit(parsed);
        setValue("");
    };

    const close = () => {
        setValue("");
        props.onClose();
    };

    return (
        <Dialog2 open onClose={close} maxWidth="xs" fullWidth>
            {/* a form so Enter submits (implicit submission) rather than falling
                through to the dialog. Cancel is type="button" so it's never the
                implicit submit target. */}
            <form onSubmit={e => { e.preventDefault(); submit(); }}>
                <DialogTitle>Standard Hinge Height</DialogTitle>
                <DialogContent>
                    <TextField
                        label={props.sys === "metric" ? "Nominal Height (mm)" : "Nominal Height"}
                        value={value}
                        onChange={e => setValue(e.currentTarget.value)}
                        onFocus={e => e.currentTarget.select()}
                        autoFocus
                        fullWidth
                        margin="dense"
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={close}>Cancel</Button>
                    <Button type="submit" disabled={!valid} variant="contained">Apply</Button>
                </DialogActions>
            </form>
        </Dialog2>
    );
}
